import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input, InputGroup, InputGroupAddon, Label,
    Row
} from 'reactstrap';

import {
    error,
    FORM,
    selectOption,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {useForm} from "react-hook-form";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/mapConfigActions";
import {connect} from "react-redux";
import {SelectPlatformWithIcon} from "../../../components/select/selectPlatformWithIcon";

function MapConfigForm(props) {

    const { editMode, domainObject } = props.formProps;
    const { udn } = props.mainProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [showModal, setShowModal] = useState(true)
    const [platform, setPlatform] = useState(domainObject?.platform || null);
    const modalRef = useRef(null);

    // Modal de posicion
    const [B1, setB1] = useState(editMode ? { lat: parseFloat(domainObject?.bound1Lat), lng: parseFloat(domainObject?.bound1Long) } :{ lat: 0.0, lng: 0.0 });
    const [B2, setB2] = useState(editMode ? { lat: parseFloat(domainObject?.bound2Lat), lng: parseFloat(domainObject?.bound2Long) } :{ lat: 0.0, lng: 0.0 });
    const [O1, setO1] = useState(editMode ? { lat: parseFloat(domainObject?.overlay1Lat), lng: parseFloat(domainObject?.overlay1Long) } :{ lat: 0.0, lng: 0.0 });
    const [O2, setO2] = useState(editMode ? { lat: parseFloat(domainObject?.overlay2Lat), lng: parseFloat(domainObject?.overlay2Long) } :{ lat: 0.0, lng: 0.0 });
    const [center, setCenter] = useState(editMode ? { lat: parseFloat(domainObject?.latitude), lng: parseFloat(domainObject?.longitude) } :{ lat: 0.0, lng: 0.0 });

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            radiusLimit: domainObject?.radiusLimit,
            defaultZoom: domainObject?.defaultZoom,
            minZoom: domainObject?.minZoom,
            maxZoom: domainObject?.maxZoom,
            imgOverlay: domainObject?.imgOverlay,

            latitude: domainObject?.latitude,
            longitude: domainObject?.longitude,

            bound1Lat: domainObject?.bound1Lat,
            bound1Long: domainObject?.bound1Long,
            bound2Lat: domainObject?.bound2Lat,
            bound2Long: domainObject?.bound2Long,

            overlay1Lat: domainObject?.overlay1Lat,
            overlay1Long: domainObject?.overlay1Long,
            overlay2Lat: domainObject?.overlay2Lat,
            overlay2Long: domainObject?.overlay2Long,

            style: domainObject?.style
        }
    });

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onPlatformChange = (value) => {
        setPlatform(value.value);
    }

    const onB1LatChange = (value) => { setB1({ lat: value, lng : B1.lng }) }

    const onB1LongChange = (value) => { setB1({  lat: B1.lat, lng : value }) }

    const onB2LatChange = (value) => { setB2({ lat: value, lng : B2.lng }) }

    const onB2LongChange = (value) => { setB2({  lat: B2.lat, lng : value }) }

    const onO1LatChange = (value) => { setO1({ lat: value, lng : O1.lng }) }

    const onO1LongChange = (value) => { setO1({  lat: O1.lat, lng : value }) }

    const onO2LatChange = (value) => { setO2({ lat: value, lng : O2.lng }) }

    const onO2LongChange = (value) => { setO2({  lat: O2.lat, lng : value }) }

    const onCenterLatChange = (value) => { setCenter({ lat: value, lng : center.lng }) }

    const onCenterLongChange = (value) => { setCenter({  lat: center.lat, lng : value }) }

    const onSubmit = (data, _) => {
        if (udn == null || platform == null) {
            return showToastCustom(error, selectOption);
        }
        let dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
                uid: domainObject?.uid,
                platform: platform,
                udn: { id: udn?.id },
            }

        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Plataforma</Label>
                                <br/>
                                <SelectPlatformWithIcon
                                    name="platform"
                                    innerRef={register}
                                    ref={register}
                                    value={platform}
                                    onChange={onPlatformChange}
                                />
                            </FormGroup>

                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>CENTRO [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="latitude" id="latitude"
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           onChange={e => onCenterLatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="longitude" id="longitude"
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               onChange={e => onCenterLongChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="imgOverlay">Overlay</Label>
                                <Input type="name" name="imgOverlay" id="imgOverlay"
                                       placeholder="Nombre imagen"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>BOUND 1 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="bound1Lat" id="bound1Lat"
                                        // value={B1?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           onChange={e => onB1LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="bound1Long" id="bound1Long"
                                            // value={ B1?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               onChange={e => onB1LongChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>OVERLAY 1 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="overlay1Lat" id="overlay1Lat"
                                        // value={O1?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           onChange={e => onO1LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="overlay1Long" id="overlay1Long"
                                            // value={ O1?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               onChange={e => onO1LongChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>BOUND 2 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="bound2Lat" id="bound2Lat"
                                        // value={B2?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           onChange={e => onB2LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="bound2Long" id="bound2Long"
                                            // value={ B2?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               onChange={e => onB2LongChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>OVERLAY 2 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="overlay2Lat" id="overlay2Lat"
                                        // value={O2?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           onChange={e => onO2LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="overlay2Long" id="overlay2Long"
                                            // value={ O2?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               onChange={e => onO2LongChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="defaultZoom">Zoom Defecto</Label>
                                <Input type="number" name="defaultZoom" id="defaultZoom"
                                       placeholder="Zoom Defecto"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="minZoom">Zoom Mínimo</Label>
                                <Input type="number" name="minZoom" id="minZoom"
                                       placeholder="Zoom Mínimo"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="maxZoom">Zoom Máximo</Label>
                                <Input type="number" name="maxZoom" id="maxZoom"
                                       placeholder="Zoom Máximo"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="radiusLimit">Radio Límite</Label>
                                <Input type="number" name="radiusLimit" id="radiusLimit"
                                       step="any"
                                       placeholder="Radio Límite"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Style</Label>
                                <Input type="textarea" rows="3" name="style" id="style"
                                       placeholder="Estilo del mapa"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(MapConfigForm)